/**
 * Extrae el `codigo_qr` (UUID) de una URL con path `/r/:codigo` o de un texto que sea solo el UUID.
 */
export function extractRestauranteCodigoFromQr(raw: string): string | null {
  const s = raw.trim();
  if (!s) return null;

  const pathMatch = /\/r\/([^/?#]+)/i.exec(s);
  if (pathMatch?.[1]) {
    const id = decodeURIComponent(pathMatch[1]).trim();
    return id || null;
  }

  try {
    if (/^https?:\/\//i.test(s)) {
      const u = new URL(s);
      const m = /\/r\/([^/?#]+)/i.exec(u.pathname);
      if (m?.[1]) {
        const id = decodeURIComponent(m[1]).trim();
        return id || null;
      }
    }
  } catch {
    /* ignore */
  }

  // Solo UUID (v4 típico; acepta cualquier variante con guiones)
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(s)) {
    return s;
  }

  return null;
}

/**
 * Código de acceso a /cdash: solo el código alfanumérico de 8 caracteres (`codigo_cdash`).
 * No se acepta UUID ni enlaces `/r/...` (eso queda para el QR público vía `extractRestauranteCodigoFromQr`).
 */
export function extractCodigoAccesoCdash(raw: string): string | null {
  const linea = raw.trim().split(/\s+/)[0]?.trim() ?? '';
  if (/^[A-Za-z0-9]{8}$/.test(linea)) {
    return linea.toUpperCase();
  }
  return null;
}
